module.exports = __webpack_public_path__ + "static/media/mill-monitor.3acc7bd2.svg";